import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  action?: { label: string; to: string };
  children?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, description, action, children }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="flex items-center gap-3">
          <span className="w-8 h-[2px] bg-primary-500" />
          <span className="font-label text-[11px] tracking-[0.28em] text-primary-300 uppercase">{eyebrow}</span>
        </div>
        <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">{title}</h2>
        {description && <p className="mt-2 text-sm leading-relaxed text-foreground-600">{description}</p>}
        {children}
      </div>
      {action && (
        <Link
          to={action.to}
          className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-400 transition-colors group shrink-0"
        >
          {action.label}
          <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-1" />
        </Link>
      )}
    </div>
  );
}